module.exports = __webpack_public_path__ + "static/img/order3.e179a0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/order3.png
// module id = 1250
// module chunks = 0